/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import '../style/result.css';
import img from '../images/Yes_check (1).svg';
import { Link } from 'react-scroll';

const Result = () => {
    return (
        <>
            <div className="servicebenefites11-section-area section-padding5">
                <div className="container">
                    <div className="row align-items-center" id='giveTop'>
                        <div className="col-lg-5" style={{ textAlign: 'start' }}>
                            <span className="font-outfit font-16 lineh-16 weight-500 color aropaln3 d-inline-block margin-b24">Results of our years of efforts</span>
                            <h1 className="font-outfit font-40 lineh-52 weight-600 color text-capitalize margin-b20" style={{ textShadow: '4px 4px 5px rgba(0, 0, 0, 0.3)', color: '#196C68', margin: '0px' }}>Dedicated Delivery, Timely Results</h1>
                            <p className="font-outfit font-16 lineh-26 weight-400 color-21 margin-b" style={{ marginTop: '10px' }}>Our team of experienced immigration consultants is here to simplify this process for you. With a deep understanding of the ever-evolving.</p>
                            <p className="font-outfit font-16 lineh-26 weight-400 color-21">Our dedicated team of experienced immigration experts is here to guide you through every step of the process.</p>
                            <Link to="contactUs" smooth={true} duration={600}>
                                <button id='btnGuide' className="font-outfit font-16 lineh-16 weight-700 color themebtn11 thmbtn12 d-inline-block margin-t32"><span>Immigration Guidance</span></button>
                            </Link>
                        </div>
                        <div className="col-lg-7" id='valueBox'>
                            <div className="immigritation-listarea">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="immigrationarea immigratation2">
                                            <div className='row'>
                                                <div className='col-2' style={{ alignItems: 'center', display: 'flex' }}>
                                                    <img src={img} width={'32px'} height={'32px'} />
                                                </div>
                                                <div className='col-10' style={{ display: 'flex', textAlign: 'left' }}>
                                                    <p className="font-16 font-outfit lineh-16 weight-600 color ts" style={{ color: 'white', fontWeight: '600', fontSize: '17px', textDecoration: 'none', }}>Get real-time and customizable reports as per your needs</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="immigrationarea immigratation2">
                                            <div className='row'>
                                                <div className='col-2' style={{ alignItems: 'center', display: 'flex' }}>
                                                    <img src={img} width={'32px'} height={'32px'} />
                                                </div>
                                                <div className='col-10' style={{ display: 'flex', textAlign: 'left' }}>
                                                    <p className="font-16 font-outfit lineh-16 weight-600 color ts" style={{ color: 'white', fontWeight: '600', fontSize: '17px', textDecoration: 'none', }}>Leverage AI technology for data automation and intelligence</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="immigrationarea immigratation2">
                                            <div className='row'>
                                                <div className='col-2' style={{ alignItems: 'center', display: 'flex' }}>
                                                    <img src={img} width={'32px'} height={'32px'} />
                                                </div>
                                                <div className='col-10' style={{ display: 'flex', textAlign: 'left' }}>
                                                    <p className="font-16 font-outfit lineh-16 weight-600 color ts" style={{ color: 'white', fontWeight: '600', fontSize: '17px', textDecoration: 'none', }}>Extra cloud-based security layer for your data privacy protection</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="immigrationarea immigratation2">
                                            <div className='row'>
                                                <div className='col-2' style={{ alignItems: 'center', display: 'flex' }}>
                                                    <img src={img} width={'32px'} height={'32px'} />
                                                </div>
                                                <div className='col-10' style={{ display: 'flex', textAlign: 'left' }}>
                                                    <p className="font-16 font-outfit lineh-16 weight-600 color ts" style={{ color: 'white', fontWeight: '600', fontSize: '17px', textDecoration: 'none', }}>We know how to save with effective resource management.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="immigrationarea immigratation2">
                                            <div className='row'>
                                                <div className='col-2' style={{ alignItems: 'center', display: 'flex' }}>
                                                    <img src={img} width={'32px'} height={'32px'} />
                                                </div>
                                                <div className='col-10' style={{ display: 'flex', textAlign: 'left' }}>
                                                    <p className="font-16 font-outfit lineh-16 weight-600 color ts" style={{ color: 'white', fontWeight: '600', fontSize: '17px', textDecoration: 'none', }}>One-stop solution for all your operational and financial needs</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="immigrationarea immigratation2">
                                            <div className='row'>
                                                <div className='col-2' style={{ alignItems: 'center', display: 'flex' }}>
                                                    <img src={img} width={'32px'} height={'32px'} />
                                                </div>
                                                <div className='col-10' style={{ display: 'flex', textAlign: 'left' }}>
                                                    <p className="font-16 font-outfit lineh-16 weight-600 color ts" style={{ color: 'white', fontWeight: '600', fontSize: '17px', textDecoration: 'none', }}>Document management with retrieval presentation</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="immigrationarea immigratation2">
                                            <div className='row'>
                                                <div className='col-2' style={{ alignItems: 'center', display: 'flex' }}>
                                                    <img src={img} width={'32px'} height={'32px'} />
                                                </div>
                                                <div className='col-10' style={{ display: 'flex', textAlign: 'left' }}>
                                                    <p className="font-16 font-outfit lineh-16 weight-600 color ts" style={{ color: 'white', fontWeight: '600', fontSize: '17px', textDecoration: 'none', }}>Latest tools and technology for effective communication</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="immigrationarea immigratation2">
                                            <div className='row'>
                                                <div className='col-2' style={{ alignItems: 'center', display: 'flex' }}>
                                                    <img src={img} width={'32px'} height={'32px'} />
                                                </div>
                                                <div className='col-10' style={{ display: 'flex', textAlign: 'left' }}>
                                                    <p className="font-16 font-outfit lineh-16 weight-600 color ts" style={{ color: 'white', fontWeight: '600', fontSize: '17px', textDecoration: 'none', }}>Always have someone by your side with our global support team</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Result;
